const baseApiUrl = 'https://e.stgapis.make.digital'; // delete this
const baseApiUrlMakeEmails = 'https://e.stgapis.make.digital'; //keep this

const baseApiUrlMakestories = 'https://api.makestories.io';

export { baseApiUrl, baseApiUrlMakestories, baseApiUrlMakeEmails };
